import React, { FC, useCallback, useEffect, useState } from 'react';
import { CircleClipPath } from '@visx/clip-path';
import { Circle } from '@visx/shape';
import { FormatUtils } from '../../../utils';
import styled from 'styled-components';
import { Text } from '@visx/text';

const StyledStackedChartText = styled.div<{ minFontSize: boolean }>`
  font-size: ${(props) => (props.minFontSize ? '9px' : '11px')};
  text-align: end;
`;
const StackedChartImage: FC<any> = ({
  d,
  showItemsPreview,
  color,
  chartId,
  setMinFontSize,
  limitText = 20,
  textWidth = 80,
  onMouseMove,
  onMouseLeave
}) => {
  const [errorLoadingImage, setErrorLoadingImage] = useState(false);

  useEffect(() => {
    setErrorLoadingImage(false);
  }, [d.pic]);

  const onErrorLoadingImage = useCallback(() => {
    setErrorLoadingImage(true);
  }, []);

  if (showItemsPreview && (!d.pic || errorLoadingImage)) {
    return (
      <svg
        overflow='visible'
        onMouseMove={(event) => onMouseMove(event, d.index)}
        onMouseLeave={(event) => onMouseLeave(event)}
      >
        <Circle r={15} cx={d.x - 15} cy={d.y} fill={color} />
        <Text
          x={d.x - 15}
          y={d.y}
          fontSize='10px'
          textAnchor='middle'
          verticalAnchor='middle'
          fill='#000000'
        >
          {d.label && d.label.substring(0, 2).toUpperCase()}
        </Text>
      </svg>
    );
  }

  if (!showItemsPreview) {
    return (
      <svg
        overflow='visible'
        onMouseMove={(event) => onMouseMove(event, d.index)}
        onMouseLeave={(event) => onMouseLeave(event)}
      >
        <foreignObject
          x={d.x - textWidth}
          y={d.y - 5}
          width={textWidth}
          height={80}
        >
          <StyledStackedChartText minFontSize={setMinFontSize}>
            {FormatUtils.capitalizeString(
              FormatUtils.truncateString(d.label, limitText)
            )}
          </StyledStackedChartText>
        </foreignObject>
      </svg>
    );
  }

  return (
    <svg
      overflow='visible'
      onMouseMove={(event) => onMouseMove(event, d.index)}
      onMouseLeave={(event) => onMouseLeave(event)}
    >
      <image
        href={d.pic}
        height={30}
        width={30}
        clipPath={`url(#category-${chartId}-icon-${d.id})`}
        x={d.x - 30}
        y={d.y - 15}
        onError={onErrorLoadingImage}
      />
      <CircleClipPath
        id={`category-${chartId}-icon-${d.id}`}
        key={`category-${chartId}-icon-${d.id}`}
        r={15}
        cx={d.x - 15}
        cy={d.y}
      />
    </svg>
  );
};

export default StackedChartImage;
